<template>
<span>
  <span
    v-if="isCorrect === null"
    class="has-text-warning-dark is-inline-block"
    :class="{'has-text-weight-semibold': isBold}"
  >{{ $t('term.ungraded') }}</span>
  <span
    v-else-if="isCorrect === true"
    class="has-text-success is-inline-block"
    :class="{'has-text-weight-semibold': isBold}"
  >{{ $t('term.correct') }}</span>
  <span
    v-else-if="isCorrect === false"
    class="has-text-danger is-inline-block"
    :class="{'has-text-weight-semibold': isBold}"
  >{{ $t('term.incorrect') }}</span>
</span>
</template>
<script>
export default{
  name: 'CorrectStatus',

  components: {
  },

  props: {
    isCorrect: {
      type: Boolean,
      default: null,
    },

    isBold: {
      type: Boolean,
      default: true,
    },
  },

  data(){
    return {
    }
  },

  computed: {
  },

  watch: {
  },

  created() {
  },

  destroyed() {
  },

  methods: {
  },
}
</script>

